import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("pl_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function fileUrl(path) {
  if (!path) return null;
  const token = localStorage.getItem("pl_token");
  return `${API}/files?path=${encodeURIComponent(path)}&auth=${token}`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/uploads", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.path;
}
